<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none mr-2">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-md-flex">
      <div class="d-flex flex-column">
        <div class="text-muted font-small-2">
          CNPJ
        </div>
        <h5>{{ institution.cnpj }}</h5>
      </div>
      <div class="d-flex flex-column ml-1">
        <div class="text-muted font-small-2">
          Instituição
        </div>
        <h5>{{ institution.name }}</h5>
      </div>
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template #button-content>
          <div class="d-sm-flex d-none user-nav">
            <p class="user-name font-weight-bolder mb-0">
              {{ userData.name }}
            </p>
            <span class="user-status">{{ userData.access_type }}</span>
          </div>
          <b-avatar
            size="40"
            variant="light-primary"
            badge
            :text="avatarText(userData.name)"
            class="badge-minimal"
            badge-variant="success"
          />
        </template>

        <b-dropdown-item
          v-b-modal.modal-profile
          link-class="d-flex align-items-center"
        >
          <feather-icon
            size="16"
            icon="UserIcon"
            class="mr-50"
          />
          <span>Meu Perfil</span>
        </b-dropdown-item>

        <b-dropdown-divider />

        <b-dropdown-item
          link-class="d-flex align-items-center"
          @click="logout"
        >
          <feather-icon
            size="16"
            icon="LogOutIcon"
            class="mr-50"
          />
          <span>Sair</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
    <profile-edit />
  </div>
</template>

<script>
import {
  BLink, BNavbarNav, BNavItemDropdown, BDropdownItem, BDropdownDivider, BAvatar, VBModal,
} from 'bootstrap-vue'
import { initialAbility } from '@/libs/acl/config'
import useSanctum from '@/auth/sanctum/useSanctum'
import { avatarText } from '@core/utils/filter'
import ProfileEdit from '@/views/profile/profile-edit/ProfileEdit.vue'
import { VueMaskFilter } from 'v-mask'

export default {
  components: {
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
    ProfileEdit,
  },
  directives: {
    'b-modal': VBModal,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      avatarText,
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  computed: {
    institution() {
      if (!this.userData?.authenticated_institution) return null
      const { authenticated_institution: institution } = this.userData
      return {
        name: institution.name,
        cnpj: VueMaskFilter(institution.cnpj, '##.###.###/####-##'),
      }
    },
  },
  methods: {
    logout() {
      useSanctum.logout()
        .then(() => {
          // Remove userData from localStorage
          localStorage.removeItem('userData')

          // Reset ability
          this.$ability.update(initialAbility)

          // Redirect to login page
          this.$router.push({ name: 'login' })
        })
    },
  },
}
</script>
